export default __webpack_public_path__ + "static/media/077-tile.c79337c3.svg";